import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { IdentityProvisioningService } from "../../identity-provisioning/identity-provisioning.service";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { EmpDetails } from "@aptsi-types";

@Component({
  selector: "app-terminate-dialog",
  template: `
    <div class="modal-header mx-3 pt-4 ">
      <h1 class="modal-title  w-100">{{ data.title }}</h1>
    </div>
    <div class="modal-body mx-3">
      <div class="row mb-1">
        <form *ngIf="form" [formGroup]="form" (ngSubmit)="import()">
          <div class="col-8">
            <div class="mb-3">
              <label class="form-label" for="status">New Status:</label>
              <select class="form-select" id="status" formControlName="status">
                <option *ngFor="let option of statusOptions" [value]="option">
                  {{ option }}
                </option>
              </select>
              <div
                *ngIf="
                  form.get('status').invalid &&
                  form.get('status').hasError('noneSelected') &&
                  (form.get('status').dirty || form.get('status').touched)
                "
              >
                <small class="text-danger">*Status cannot be None</small>
              </div>
            </div>
          </div>

          <div class="col-8">
            <div class="mb-3">
              <label class="form-label">Description:</label>
              <textarea
                type="text"
                name="Enter Description"
                required
                ng-maxlength="100"
                #textBox1Control
                formControlName="description"
              >
              </textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="mx-3 mb-3 ">
       <button type="button" class="btn btn-dark me-2" (click)="cancel()">
        cancel
      </button>
      <button type="button" class="btn btn-danger" (click)="terminateEmp()">
        Status Change
      </button>
    </div>
  `,
})
export class TerminateDialogComponent implements OnInit {
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      digitalId: string;
      path: string;
      orgnization: string;
      pathoverride: string;
      reason: string;
    },
    private dialogRef: MatDialogRef<TerminateDialogComponent>, // Use dialogRef instead of dialog
    private identityProvisioningService: IdentityProvisioningService
  ) {}

  form: FormGroup;
  empDetails: EmpDetails[] = [];
  nullver: number = 1;

  readonly statusOptions = [
    "Termination",
    "Resignation",
    "Retirement",
    "Contract Expiration",
    "Layoff",
    "None",
  ];

  async ngOnInit(): Promise<void> {
    this.form = new FormGroup({
      status: new FormControl("None", [
        Validators.required,
        this.typeValidator,
      ]),
      description: new FormControl(null, Validators.required),
    });
  }

  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    const selectedType = control.value;
    if (selectedType === "None") {
      return { noneSelected: true };
    }
    return null;
  }

  cancel() {
    this.dialogRef.close({ success: false }); // Send false when canceled
    this.router.navigate([this.data.path]);
  }

  async terminateEmp() {
    try {
      this.data.reason = this.form.value.status;

      const response = await this.identityProvisioningService
        .terminateEmpDetail(
          this.form.value.status,
          this.form.value.description,
          this.data.digitalId
        )
        .toPromise();

      this.dialogRef.close({ success: true, reason: this.data.reason }); // Send success as true with reason
    } catch (error) {
      console.error("Error terminating employee:", error);
    }
  }
}
